<template>
    <div>
        <form @submit.prevent="uploadFile">
            <input type="file" ref="fileInput" accept="image/*">
            <button type="submit" class="btn btn-outline-success">Upload</button>
            <p>url: {{response}}</p>
            <img :src="response" alt="">
        </form>
        <br>
        <br>
        <br>
        <div class="mt-4">
            <p>#Note: Need ChatGPT api key</p>
            <p>test chat GPT: {{ chat_completion }}</p>
            <button class="btn btn-success" @click="callGPT">Gửi GPT</button>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
const { Configuration, OpenAIApi } = require("openai");
export default {
    data() {
        return {
            chat_completion: null,
            response: null,
        }
    },
    methods: {
        ...mapActions('upload', ['UploadSingleFile']),
        async callGPT() {
            const configuration = new Configuration({
                apiKey: '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',
            });
            const openai = new OpenAIApi(configuration);
            this.chat_completion = await openai.createChatCompletion({
                model: "gpt-3.5-turbo",
                messages: [{ role: "user", content: "Hello world" }],
            });
        },
        async uploadFile() {
            const file = this.$refs.fileInput.files[0];
            const formData = new FormData();
            formData.append('file', file);
            const response = await this.UploadSingleFile(formData)
            this.response = this.$addPrefix(response.url)
        },
    },
}
</script>